import { Navigate, Route } from "react-router-dom";

import GeneralSettings from "../../GeneralSettings";
import { TenantGeneralSettings } from "../../TenantGeneralSettings";
import { contractTemplateRoutes } from "../../ContractTemplate";
import { List as ListRoles, NewRole, EditRole } from "../../Roles/components";
import { List as ListUsers, NewUSer, EditUser } from "../../Users/components";
import { organizationRoutes } from "../../Organizations";
import { adminRoutes as platformAdminRoutes } from "../../Admins";
import { UserOrganization } from "../../Organizations/components";
import { FormulaEditor } from "../components/FormulaEditor";
import { Integrations, ConfigureIntegration } from "../../";

import manufactureRoutes from "../../Manufacture/routes";
import productCategoryRoutes from "../../ProductCategory/routes";

const adminRoutes = [
    <Route
        index
        element={<Navigate to="general" replace />}
        key={"admin:index"}
    />,
    <Route path="general" element={<GeneralSettings />} key={"list"} />,
    <Route
        path="tenant/general"
        element={<TenantGeneralSettings />}
        key={"admin:tenant-general"}
    />,
    <Route
        path="formulas"
        element={<FormulaEditor />}
        key={"admin:formulas"}
    />,
    <Route
        path="integrations"
        element={<Integrations />}
        key={"admin:integrations"}
    />,
    <Route
        path="integrations/:integrationId"
        element={<ConfigureIntegration />}
        key={"admin:integrations:configure"}
    />,

    <Route path="manufacture" key={"manufacture"}>
        {manufactureRoutes}
    </Route>,
    <Route path="product-category" key={"product-category"}>
        {productCategoryRoutes}
    </Route>,
    <Route path="org" element={<UserOrganization />} key={"org-settings"} />,
    <Route path="contract-template" key={"contract-template"}>
        {contractTemplateRoutes}
    </Route>,
    <Route path="suppliers" element={<div>test</div>} key={"list:details"} />,
    <Route path="roles" element={<ListRoles />} key={"roles:list"} />,
    <Route path="roles/new" element={<NewRole />} key={"roles:new"} />,
    <Route path="roles/edit/:id" element={<EditRole />} key={"roles:edit"} />,
    <Route path="users" element={<ListUsers />} key={"users:list"} />,
    <Route path="users/new" element={<NewUSer />} key={"users:new"} />,
    <Route path="users/edit/:id" element={<EditUser />} key={"users:edit"} />,
    <Route path="organizations" key={"organizations"}>
        {organizationRoutes}
    </Route>,
    <Route path="tenant/admins" key={"platform-admins"}>
        {platformAdminRoutes}
    </Route>,
];

export default adminRoutes;
